import forOwn from "mout/object/forOwn"

export default function initializeAnswers(items, destructuredSubtests) {
  let answers = {}
  forOwn(destructuredSubtests, (val, key, o) => {
    answers[key] = []
    val.items.forEach(item => {
      if (items && items[item]) {
        const contentItem = items[item]
        let correctAnswer = ""
        forOwn(contentItem.answers, (answer, answerKey) => {
          if (answer.correct) {
            correctAnswer = answerKey
          }
        })

        if (contentItem.itemType === "Grid In") {
          correctAnswer = Object.values(contentItem.answers)
            .filter(item => item.correct)
            .map(item => item.answer)
            .toString()
        }
        answers[key].push(correctAnswer)
      }
    })
  })
  return answers
}
